import { render, staticRenderFns } from "./pending-dispatch.vue?vue&type=template&id=58d75aab&scoped=true"
import script from "./pending-dispatch.vue?vue&type=script&lang=ts"
export * from "./pending-dispatch.vue?vue&type=script&lang=ts"
import style0 from "./pending-dispatch.vue?vue&type=style&index=0&id=58d75aab&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d75aab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58d75aab')) {
      api.createRecord('58d75aab', component.options)
    } else {
      api.reload('58d75aab', component.options)
    }
    module.hot.accept("./pending-dispatch.vue?vue&type=template&id=58d75aab&scoped=true", function () {
      api.rerender('58d75aab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/pending-dispatch.vue"
export default component.exports